import React, { useState, Children } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, FolderOpen, Settings, LogOut, Plus, CreditCard, History, ChevronDown, ChevronRight, UserCircle, Users, Key, Shield, Video, Image, Target, Folder, Trash2, Edit3, Film } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ProjectFolder {
  id: string;
  name: string;
  children: ProjectFolder[];
}
export function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [projectsOpen, setProjectsOpen] = useState(false);
  const [editingId, setEditingId] = useState<string | null>(null);
  const [editName, setEditName] = useState('');
  const [folders, setFolders] = useState<ProjectFolder[]>([{
    id: '1',
    name: 'Campaña Q1 2025',
    children: [{
      id: '1-1',
      name: 'Facebook Ads',
      children: []
    }, {
      id: '1-2',
      name: 'Google Ads',
      children: []
    }]
  }, {
    id: '2',
    name: 'Lanzamiento Producto',
    children: []
  }]);
  const navItems = [{
    icon: Home,
    label: 'Inicio',
    path: '/dashboard'
  }, {
    icon: History,
    label: 'Campañas Recientes',
    path: '/dashboard/campanas'
  }, {
    icon: Target,
    label: 'Pautas Activas',
    path: '/dashboard/pautas'
  }, {
    icon: CreditCard,
    label: 'Facturación',
    path: '/dashboard/billing'
  }];
  const mediaSubItems = [{
    icon: Video,
    label: 'Videos',
    path: '/dashboard/media/heygen'
  }, {
    icon: Image,
    label: 'Imágenes',
    path: '/dashboard/media/higgsfield'
  }];
  const settingsSubItems = [{
    icon: UserCircle,
    label: 'Clientes',
    path: '/dashboard/settings/clientes'
  }, {
    icon: Users,
    label: 'Usuarios',
    path: '/dashboard/settings/usuarios'
  }, {
    icon: Settings,
    label: 'Catálogos',
    path: '/dashboard/settings/catalogos'
  }, {
    icon: Key,
    label: 'Llaves',
    path: '/dashboard/settings/llaves'
  }, {
    icon: Shield,
    label: 'Seguridad',
    path: '/dashboard/settings/seguridad'
  }];
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    navigate('/login');
  };
  const addFolder = (parentId?: string) => {
    const newFolder: ProjectFolder = {
      id: Date.now().toString(),
      name: 'Nuevo Proyecto',
      children: []
    };
    if (parentId) {
      setFolders(prev => updateFolderChildren(prev, parentId, newFolder));
    } else {
      setFolders(prev => [...prev, newFolder]);
    }
    setEditingId(newFolder.id);
    setEditName('Nuevo Proyecto');
  };
  const updateFolderChildren = (folders: ProjectFolder[], parentId: string, newChild: ProjectFolder): ProjectFolder[] => {
    return folders.map(folder => {
      if (folder.id === parentId) {
        return {
          ...folder,
          children: [...folder.children, newChild]
        };
      }
      if (folder.children.length > 0) {
        return {
          ...folder,
          children: updateFolderChildren(folder.children, parentId, newChild)
        };
      }
      return folder;
    });
  };
  const deleteFolder = (id: string) => {
    setFolders(prev => deleteFolderById(prev, id));
  };
  const deleteFolderById = (folders: ProjectFolder[], id: string): ProjectFolder[] => {
    return folders.filter(folder => folder.id !== id).map(folder => ({
      ...folder,
      children: deleteFolderById(folder.children, id)
    }));
  };
  const renameFolder = (id: string, newName: string) => {
    setFolders(prev => renameFolderById(prev, id, newName));
    setEditingId(null);
  };
  const renameFolderById = (folders: ProjectFolder[], id: string, newName: string): ProjectFolder[] => {
    return folders.map(folder => {
      if (folder.id === id) {
        return {
          ...folder,
          name: newName
        };
      }
      return {
        ...folder,
        children: renameFolderById(folder.children, id, newName)
      };
    });
  };
  const renderFolder = (folder: ProjectFolder, level: number = 0) => {
    const isActive = location.pathname === `/dashboard/proyectos/${folder.id}`;
    return <div key={folder.id} style={{
      marginLeft: level * 12
    }} data-id="element-102">
        <div className={`group flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-all duration-200 ${isActive ? 'bg-white/10 text-white' : 'text-gray-500 hover:text-white hover:bg-white/5'}`} data-id="element-103">
          <Folder className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-orange-500' : ''}`} data-id="element-104" />

          {editingId === folder.id ? <input type="text" value={editName} onChange={e => setEditName(e.target.value)} onBlur={() => renameFolder(folder.id, editName)} onKeyDown={e => {
          if (e.key === 'Enter') renameFolder(folder.id, editName);
          if (e.key === 'Escape') setEditingId(null);
        }} className="flex-1 bg-white/10 border-none outline-none text-white text-sm px-1 py-0.5 rounded" autoFocus data-id="element-105" /> : <Link to={`/dashboard/proyectos/${folder.id}`} className="flex-1 truncate" data-id="element-106">
              {folder.name}
            </Link>}

          <div className="opacity-0 group-hover:opacity-100 flex items-center gap-1 transition-opacity" data-id="element-107">
            <button onClick={e => {
            e.preventDefault();
            addFolder(folder.id);
          }} className="p-1 hover:bg-white/10 rounded" title="Agregar subcarpeta" data-id="element-108">
              <Plus className="w-3 h-3" data-id="element-109" />
            </button>
            <button onClick={e => {
            e.preventDefault();
            setEditingId(folder.id);
            setEditName(folder.name);
          }} className="p-1 hover:bg-white/10 rounded" title="Renombrar" data-id="element-110">
              <Edit3 className="w-3 h-3" data-id="element-111" />
            </button>
            <button onClick={e => {
            e.preventDefault();
            deleteFolder(folder.id);
          }} className="p-1 hover:bg-red-500/20 rounded text-red-400" title="Eliminar" data-id="element-112">
              <Trash2 className="w-3 h-3" data-id="element-113" />
            </button>
          </div>
        </div>

        {folder.children.length > 0 && <div className="mt-1" data-id="element-114">
            {folder.children.map(child => renderFolder(child, level + 1))}
          </div>}
      </div>;
  };
  const isSettingsActive = location.pathname.startsWith('/dashboard/settings');
  const isMediaActive = location.pathname.startsWith('/dashboard/media');
  const isProjectsActive = location.pathname.startsWith('/dashboard/proyectos');
  return <aside className="hidden md:flex flex-col w-64 h-screen bg-[#1C1C1C] text-white border-r border-white/5 fixed left-0 top-0 z-40" data-id="element-115">
      {/* Logo */}
      <div className="p-6" data-id="element-116">
        <Link to="/" className="flex items-center gap-2 group" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/6der9p7cTuhPYDgtJnKRAY/Group_1448.svg" alt="Danke Consulting" className="h-8 brightness-0 invert group-hover:scale-105 transition-transform duration-300" data-id="element-118" />
        </Link>
      </div>

      {/* New Campaign Button */}
      <div className="px-4 mb-6" data-id="element-119">
        <button onClick={() => navigate('/dashboard/proyectos/nuevo')} className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-pink-500 text-white font-medium py-2.5 rounded-xl hover:opacity-90 transition-all hover:scale-[1.02] active:scale-[0.98]" data-id="element-120">
          <Plus className="w-4 h-4" data-id="element-121" />
          Nuevo Proyecto
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-2 space-y-1 overflow-y-auto" data-id="element-122">
        {/* Main nav items */}
        {navItems.slice(0, 1).map(item => {
        const isActive = location.pathname === item.path;
        return <Link key={item.path} to={item.path} className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${isActive ? 'bg-white/10 text-white' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-123">
              <item.icon className={`w-5 h-5 ${isActive ? 'text-orange-500' : ''}`} data-id="element-124" />
              {item.label}
            </Link>;
      })}

        {/* Projects with folders */}
        <div data-id="element-125">
          <button onClick={() => setProjectsOpen(!projectsOpen)} className={`w-full flex items-center justify-between gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${isProjectsActive ? 'bg-white/10 text-white' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-126">
            <div className="flex items-center gap-3" data-id="element-127">
              <FolderOpen className={`w-5 h-5 ${isProjectsActive ? 'text-orange-500' : ''}`} data-id="element-128" />
              Proyectos
            </div>
            <div className="flex items-center gap-1" data-id="element-129">
              <button onClick={e => {
              e.stopPropagation();
              addFolder();
            }} className="p-1 hover:bg-white/10 rounded" title="Nuevo proyecto" data-id="element-130">
                <Plus className="w-3 h-3" data-id="element-131" />
              </button>
              {projectsOpen ? <ChevronDown className="w-4 h-4" data-id="element-132" /> : <ChevronRight className="w-4 h-4" data-id="element-133" />}
            </div>
          </button>

          <AnimatePresence data-id="element-134">
            {projectsOpen && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} transition={{
            duration: 0.2
          }} className="overflow-hidden" data-id="element-135">
                <div className="ml-4 mt-1 space-y-1 border-l border-white/10 pl-2" data-id="element-136">
                  {folders.map(folder => renderFolder(folder))}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        {/* Campañas Recientes */}
        <Link to="/dashboard/campanas" className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${location.pathname === '/dashboard/campanas' ? 'bg-white/10 text-white' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-137">
          <History className={`w-5 h-5 ${location.pathname === '/dashboard/campanas' ? 'text-orange-500' : ''}`} data-id="element-138" />
          Campañas Recientes
        </Link>

        {/* Pautas Activas */}
        <Link to="/dashboard/pautas" className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${location.pathname === '/dashboard/pautas' ? 'bg-white/10 text-white' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-139">
          <Target className={`w-5 h-5 ${location.pathname === '/dashboard/pautas' ? 'text-orange-500' : ''}`} data-id="element-140" />
          Pautas Activas
        </Link>

        {/* Media with Submenu */}
        <div data-id="element-141">
          <button onClick={() => setMediaOpen(!mediaOpen)} className={`w-full flex items-center justify-between gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${isMediaActive ? 'bg-white/10 text-white' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-142">
            <div className="flex items-center gap-3" data-id="element-143">
              <Film className={`w-5 h-5 ${isMediaActive ? 'text-orange-500' : ''}`} data-id="element-144" />
              Media
            </div>
            {mediaOpen ? <ChevronDown className="w-4 h-4" data-id="element-145" /> : <ChevronRight className="w-4 h-4" data-id="element-146" />}
          </button>

          <AnimatePresence data-id="element-147">
            {mediaOpen && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} transition={{
            duration: 0.2
          }} className="overflow-hidden" data-id="element-148">
                <div className="ml-4 mt-1 space-y-1 border-l border-white/10 pl-4" data-id="element-149">
                  {mediaSubItems.map(subItem => {
                const isSubActive = location.pathname === subItem.path;
                return <Link key={subItem.path} to={subItem.path} className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all duration-200 ${isSubActive ? 'bg-white/10 text-white' : 'text-gray-500 hover:text-white hover:bg-white/5'}`} data-id="element-150">
                        <subItem.icon className={`w-4 h-4 ${isSubActive ? 'text-orange-500' : ''}`} data-id="element-151" />
                        {subItem.label}
                      </Link>;
              })}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        {/* Facturación */}
        <Link to="/dashboard/billing" className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${location.pathname === '/dashboard/billing' ? 'bg-white/10 text-white' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-152">
          <CreditCard className={`w-5 h-5 ${location.pathname === '/dashboard/billing' ? 'text-orange-500' : ''}`} data-id="element-153" />
          Facturación
        </Link>

        {/* Settings with Submenu */}
        <div data-id="element-154">
          <button onClick={() => setSettingsOpen(!settingsOpen)} className={`w-full flex items-center justify-between gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${isSettingsActive ? 'bg-white/10 text-white' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-155">
            <div className="flex items-center gap-3" data-id="element-156">
              <Settings className={`w-5 h-5 ${isSettingsActive ? 'text-orange-500' : ''}`} data-id="element-157" />
              Configuración
            </div>
            {settingsOpen ? <ChevronDown className="w-4 h-4" data-id="element-158" /> : <ChevronRight className="w-4 h-4" data-id="element-159" />}
          </button>

          <AnimatePresence data-id="element-160">
            {settingsOpen && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} transition={{
            duration: 0.2
          }} className="overflow-hidden" data-id="element-161">
                <div className="ml-4 mt-1 space-y-1 border-l border-white/10 pl-4" data-id="element-162">
                  {settingsSubItems.map(subItem => {
                const isSubActive = location.pathname === subItem.path;
                return <Link key={subItem.path} to={subItem.path} className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all duration-200 ${isSubActive ? 'bg-white/10 text-white' : 'text-gray-500 hover:text-white hover:bg-white/5'}`} data-id="element-163">
                        <subItem.icon className={`w-4 h-4 ${isSubActive ? 'text-orange-500' : ''}`} data-id="element-164" />
                        {subItem.label}
                      </Link>;
              })}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </nav>

      {/* User Profile */}
      <div className="p-4 border-t border-white/5" data-id="element-165">
        <div className="flex items-center gap-3 p-2 rounded-xl hover:bg-white/5 cursor-pointer transition-colors" data-id="element-166">
          <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-orange-400 to-pink-500 flex items-center justify-center text-xs font-bold text-white" data-id="element-167">
            AD
          </div>
          <div className="flex-1 min-w-0" data-id="element-168">
            <p className="text-sm font-medium text-white truncate" data-id="element-169">
              Administrador
            </p>
            <p className="text-xs text-gray-500 truncate" data-id="element-170">admin@danke.com</p>
          </div>
          <button onClick={handleLogout} className="p-1.5 rounded-lg hover:bg-white/10 transition-colors" title="Cerrar sesión" data-id="element-171">
            <LogOut className="w-4 h-4 text-gray-500 hover:text-white transition-colors" data-id="element-172" />
          </button>
        </div>
      </div>
    </aside>;
}